module.exports = __webpack_public_path__ + "static/media/mainPicMobile.1428870e.png";